















import Vue from 'vue'
import Analytics from '@/services/Analytics'
import AppTitle from '@/components/AppTitle.vue'
import CloseButton from '@/components/CloseButton.vue'
import events from '@/events/events'
import User from '@/types/User.interface'
import RegistrationForm from '@/components/RegistrationForm.vue'
export default Vue.extend({
    components: { AppTitle, RegistrationForm, CloseButton },
    mounted() {
        this.goToStep()

        //  Track page view in google analytics
        // Analytics.gaPageView(this.$route)
    },
    computed: {
        queryStr(): string {
            //  Assemble the query params to forward to the next route
            return this.$route.query ? `?${window.toUrlParams(this.$route.query)}` : ''
        },
        user(): User {
            return this.$store.getters.user
        }
    },
    methods: {
        isIntuitAppstore(): boolean {
            //  We know this registration is from intuit's appstore if the method is set
            return this.$route.query.method === 'subscribeFromAppstore'
        },
        async goToStep(): Promise<void> {
            //  Check if the user can pass registration step
            const validUser = await this.validateUser()

            //  If the user is NOT valid, do nothing
            if (!validUser) return

            //  Check if the user can pass the verification step
            const validVerify = this.user.email_verified == true

            //  If the user is NOT valid, route to email verification
            if (!validVerify) return this.$router.push(`/register/verify${this.queryStr}`)

            //  Fetch the stripe customer
            const customer = await this.$store.dispatch('stripeCustomerFind', false)

            //  Check if the user can pass the payment card step
            const validPay = customer && customer.default_source !== null

            //  If the user does NOT have a payment source, route to payment step
            if (!validPay) return this.$router.push(`/register/verify${this.queryStr}`)

            //  Check if the user has zero memberships
            const validTenant = this.user.memberships.length > 0

            //  If the user does NOT have a valid tenant, route to tenant build
            if (!validTenant) this.$router.push(`/register/building${this.queryStr}`)
        },
        async userUpdate(_user: User): Promise<void> {
            //  Split the full name into first and last
            const names = _user.fullname.split(' ')

            //  First name is the first index
            _user.firstname = names.splice(0, 1)[0]

            //  Last name is every other index combined
            _user.lastname = names.join(' ')

            //  Make sure terms are accepted
            _user.terms_accepted = true

            //  Update the currently authenticated user
            const user = await this.$store.dispatch('authUserRegister', _user)

            //  If the request failed, do nothing
            if (!user) return

            //  Else, publish the user registered event
            events.onUserRegistered(user)

            //  If this registration is coming from intuit's appstore, we have special handling
            if (this.isIntuitAppstore()) return this.subscribeFromAppstore()

            //  Registration from Xero
            if (this.$route.query.provider === 'xero') {
                return this.$router.push('/register/verify?provider=xero')
            }

            //  Else, route user to email verfication
            this.$router.push('/register/verify')
        },
        //  Skip the verification step if the registration is coming from intuit's appstore
        subscribeFromAppstore(): void {
            //  Forward the 'method' url param to payment step
            this.$router.push('/register/verify?method=subscribeFromAppstore')
        },
        async validateUser(): Promise<boolean> {
            const rules = [
                {
                    key: 'email',
                    val: this.user.email,
                    req: 'required|email'
                },
                {
                    key: 'mobilephone',
                    val: this.user.mobilephone,
                    req: 'required|phone'
                }
            ]

            //  Create a container for validation errors
            const errors = []

            //  Validate each rule
            for (let i = 0; i < rules.length; i++) {
                //  Get the rule
                const rule = rules[i]

                //  Validate the field
                const validation = await this.$validator.verify(rule.val, rule.req)

                //  If the field is NOT valid, add the error to the errors array
                if (!validation.valid) errors.push({ key: rule.key, ...validation })
            }

            //  The user is valid is there are zero errors
            return errors.length === 0
        }
    }
})
